<div class="bg-transparent" [hidden]="!errorDataObj.IsError && hideInFtWeb">
    <div class="modal error-container" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <!-- <h1 class="modal-title"><strong>{{ 'error_heading' | translate }}</strong></h1> -->
                    <h1 class="modal-title">{{ 'lbl_error_heading' | translate }}</h1>
                    <button type="button" class="close" aria-label="Close" (click)="closeErrPopup()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <!-- <i class="fa fa-times close close-icon" aria-hidden="true"
                        (click)="activeModal.dismiss('Cross click')"></i> -->
                </div>
                <div class="modal-body">
                    <p *ngIf="errorDataObj.ErrorResponse.ResponseStatus != 'undefined'">
                        {{errorDataObj.ErrorResponse.ResponseStatus}} :
                        {{errorDataObj.ErrorResponse.ResponseStatus | translate}}
                    </p>
                    <p *ngIf="errorDataObj.ErrorResponse.ResponseStatus == 'undefined'">
                        {{errorDataObj.ErrorResponse.ResponseStatus | translate}}
                    </p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary"
                        (click)="closeErrPopup()">{{ 'lbl_ok' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>